import { render, staticRenderFns } from "./SidePanelNav.vue?vue&type=template&id=5635d19c&scoped=true&"
import script from "./SidePanelNav.vue?vue&type=script&lang=js&"
export * from "./SidePanelNav.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelNav.vue?vue&type=style&index=0&id=5635d19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5635d19c",
  null
  
)

export default component.exports